import { Data } from "dataclass";
import { TripDto } from "../../../Global/models/TripDto";
import { formatToMonthRange } from "../../../utils/DateUtils";

export class CuratorCardViewModel extends Data {
  priceLine = "";
  tripDate = "";
  curatorBgImg = "";
  curatorImg = "";
  curatorName = "";
  curatorInfo = "";
  curatorInstaId = ""
}

export const mapToCuratorCardViewModel = (tripDto: TripDto) => {
  return CuratorCardViewModel.create({
    priceLine: tripDto.tripPriceLine,
    tripDate: formatToMonthRange(tripDto.tripDates) || "",
    curatorBgImg: tripDto.curatorBgImg,
    curatorImg: tripDto.curatorImg,
    curatorName: tripDto.user.fullName,
    curatorInfo: tripDto.user.influencerIntro,
    curatorInstaId: tripDto.user.instaId,
  });
};
